var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popover',{attrs:{"trigger":"hover","placement":"top"}},[_c('span',{staticClass:"text-popover-show"},[_vm._v(_vm._s(_vm.text))]),_c('div',{attrs:{"slot":"reference"},slot:"reference"},[_c('span',{staticClass:"text-show"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }